import { Box, Skeleton } from "@mui/material";
import styles from "./styles.module.css";

const BusinessOverviewCardSkeleton = () => {
  return (
    <Box className={styles.BusinessOverviewCard}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Skeleton variant="text" width={120} sx={{ fontSize: "0.875rem" }} />
        <Skeleton variant="rounded" width={85} height={32} sx={{ borderRadius: "6px" }} />
      </Box>

      <Box className={`marginTop10 ${styles.labelContainer}`}>
        <Skeleton variant="text" width={110} sx={{ fontSize: "1.25rem" }} />
        <Skeleton variant="text" width={90} sx={{ fontSize: "0.875rem" }} />
      </Box>

      <hr />

      <Box className={styles.listContainer}>
        <Skeleton variant="text" width={90} sx={{ fontSize: "0.875rem" }} />
        <Skeleton variant="text" width={80} sx={{ fontSize: "0.875rem" }} />
      </Box>

      <Box className={styles.listContainer}>
        <Skeleton variant="text" width={110} sx={{ fontSize: "0.875rem" }} />
        <Skeleton variant="text" width={80} sx={{ fontSize: "0.875rem" }} />
      </Box>

      <Skeleton variant="text" width={70} sx={{ fontSize: "0.875rem" }} />
    </Box>
  );
};

export default BusinessOverviewCardSkeleton;
